import { css } from '@emotion/css';
import { N700 } from '@assets/colors';
import { colors } from '@ajaibid/components';

export const styContainer = css`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const styNotationBox = css`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background-color: ${colors.YELLOW_5};
  cursor: default;

  text-align: center;
  line-height: 18px;
  font-size: 12px;
  color: ${colors.NEUTRAL_0};
`;

export const styBtnMore = css`
  box-sizing: border-box;
  padding: 0px 1px;
  height: 18px;
  min-width: 18px;
  border-radius: 4px;
  cursor: pointer;

  text-align: center;
  line-height: 18px;
  font-size: 14px;
  color: ${colors.YELLOW_5};

  :hover {
    background: ${colors.YELLOW_3};
  }
`;

export const styDescription = css`
  color: ${N700} !important;
`;
